import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import MenuPage from './components/MenuPage';
import ReservationPage from './components/ReservationPage';
import ContactPage from './components/ContactPage';
import AdminDashboard from './components/AdminDashboard';
import CustomerDashboard from './components/CustomerDashboard';
import LoginPage from './components/LoginPage';
import AdminRegisterPage from './components/AdminRegisterPage';
import MenuMaintenance from './components/MenuMaintenance';
import CategoryMenuPage from './components/CategoryMenuPage'; // Ensure this is imported only once
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router basename="/projects/restaurant">
          <Switch>
            <Route path="/" exact component={LandingPage} />
            <Route path="/menu" exact component={MenuPage} />
            <Route path="/menu/:category" component={CategoryMenuPage} /> {/* Dynamic menu page */}
            <Route path="/reservations" component={ReservationPage} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/admin/register" component={AdminRegisterPage} />
            <PrivateRoute path="/admin" component={AdminDashboard} />
            <PrivateRoute path="/menu-maintenance" component={MenuMaintenance} />
            <Route path="/customer" component={CustomerDashboard} />
          </Switch>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;